import React from 'react'
import { useTranslation } from 'react-i18next'
import Navigation, { NavStatusConst } from '../navigation'
// import { MemberStepInStory, StepMap2Link } from '../../shared/constant'
import { connect } from 'react-redux'

interface IWithNavProps {
  children?: any
  step?: any
  lastStep?: any
  story?: any
}

const WithNav: React.FC<IWithNavProps> = (props: IWithNavProps) => {
  const { step } = props
  const { t } = useTranslation()

  const data = [
    { text: t('lessonSteps.introduction') },
    { text: t('lessonSteps.readingListening') },
    { text: t('lessonSteps.comprehension') },
    { text: t('lessonSteps.writingSpeaking') },
    { text: t('lessonSteps.finish') },
  ]
  const _data = data.map((o, i) => {
    return {
      text: o.text,
      step: i + 1,
      status: i < step ? NavStatusConst.finished : i == step ? NavStatusConst.active : NavStatusConst.notFinish,
    }
  })
  return (
    <>
      <Navigation data={_data} activeStep={step} />
      {props.children}
    </>
  )
}

const mapStateToProps = (state: any) => ({
  lastStep: state.story.lastStep,
  story: state.story.currentStory,
})
export default connect(mapStateToProps)(WithNav)
